import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <defs>
      <linearGradient id="b" x1={0.094} x2={1.187} y1={0.056} y2={0.579}>
        <stop offset="0%" stopColor="#F2603E" />
        <stop offset="100%" stopColor="#F38B2B" />
      </linearGradient>
      <clipPath id="a">
        <rect width={16} height={16} rx={0} />
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <path
        fill="#F2603E"
        d="M8.015.507C3.569.507.022 3.804.022 7.9c0 1.299.35 2.498.95 3.597.1.15.15.35.05.599l-1 2.822c-.1.25.15.5.45.45l2.847-1.1c.15-.05.35-.05.55.05a8.285 8.285 0 0 0 4.146 1.1c4.445-.05 7.992-3.347 7.992-7.443-.05-4.17-3.597-7.468-7.992-7.468Zm3.646 10.215c-.2.45-.95.85-1.299.85-.35 0-.35.25-2.248-.55-1.898-.85-3.047-2.897-3.146-2.997-.1-.15-.75-1.049-.7-1.998.05-.95.55-1.399.75-1.549.2-.2.4-.2.499-.2h.35c.1 0 .3 0 .4.35.15.4.499 1.349.549 1.449.05.1.05.2 0 .35-.05.15-.1.2-.2.3-.1.1-.2.249-.3.349-.1.1-.2.2-.1.4s.45.849 1 1.348c.699.7 1.298.9 1.498 1 .2.1.3.1.4-.05.1-.1.499-.55.649-.75.15-.2.25-.15.45-.1.15.05 1.098.55 1.298.65.2.1.3.15.35.25-.05.1-.05.499-.2.898Z"
        style={{
          mixBlendMode: "passthrough",
        }}
      />
      <path
        fill="url(#b)"
        d="M8.015.507C3.569.507.022 3.804.022 7.9c0 1.299.35 2.498.95 3.597.1.15.15.35.05.599l-1 2.822c-.1.25.15.5.45.45l2.847-1.1c.15-.05.35-.05.55.05a8.285 8.285 0 0 0 4.146 1.1c4.445-.05 7.992-3.347 7.992-7.443-.05-4.17-3.597-7.468-7.992-7.468Zm3.646 10.215c-.2.45-.95.85-1.299.85-.35 0-.35.25-2.248-.55-1.898-.85-3.047-2.897-3.146-2.997-.1-.15-.75-1.049-.7-1.998.05-.95.55-1.399.75-1.549.2-.2.4-.2.499-.2h.35c.1 0 .3 0 .4.35.15.4.499 1.349.549 1.449.05.1.05.2 0 .35-.05.15-.1.2-.2.3-.1.1-.2.249-.3.349-.1.1-.2.2-.1.4s.45.849 1 1.348c.699.7 1.298.9 1.498 1 .2.1.3.1.4-.05.1-.1.499-.55.649-.75.15-.2.25-.15.45-.1.15.05 1.098.55 1.298.65.2.1.3.15.35.25-.05.1-.05.499-.2.898Z"
        style={{
          mixBlendMode: "passthrough",
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
